import type { LaunchGeoProduct } from '@/store/slices/game/types';

const PLAYTECH_POKER_PROVIDER = 'PLAYTECHPOKER';

type ResolveLaunchGeoProductInput = {
  runtimeProduct?: string | null;
  providerName?: string | null;
  isAndroid: boolean;
};

/**
 * The shell product and the product required by the launched game can differ.
 * Poker web launches are casino games; Android short links stay unknown until
 * either aggregation or GLS resolves their provider.
 */
export const resolveLaunchGeoProduct = ({
  runtimeProduct,
  providerName,
  isAndroid,
}: ResolveLaunchGeoProductInput): LaunchGeoProduct => {
  if (runtimeProduct?.toUpperCase() !== 'POKER') {
    return 'CASINO';
  }

  const normalizedProvider = providerName?.replace(/[_-]/g, '').toUpperCase();
  if (normalizedProvider) {
    return normalizedProvider === PLAYTECH_POKER_PROVIDER ? 'POKER' : 'CASINO';
  }

  return isAndroid ? 'UNKNOWN' : 'CASINO';
};
